module.exports = __webpack_public_path__ + "img/badge-most-conversion-bronze.7d0b7d3b.png";